import './Three.css';

// const newTab = () => {
//     window.open(this.href);
//     return true;
// };

// const afterPress = () => {
//     window.open(this.href);
//     return true;
// }

function Three({ text, pageRef }){

    const Text = text.Publication;

    return(
        <div id='IdThree' className='three' ref={pageRef}>
            <div className='boxPage3'>
                <div className='smallBoxPaper'>{text.main.titlePublication}</div>
                <div className='allBoxPapers'>
                    <div className='boxPaper right'>
                        <div className='title'>{Text.p8.title}</div>
                        <div className="nameConf">{Text.p8.conference}</div>
                        {/* <div id="date">دوم و سوم آذر ماه سال ۱۳۹۶، دانشگاه علم و صنعت، تهران</div> */}
                    </div>
                    <div className='boxPaper left'>
                        <div className="title">{Text.p7.title}</div>
                        <div className="nameConf">{Text.p7.conference}</div>
                    </div>
                    <div className='boxPaper right'>
                        <div className='title'>{Text.p6.title}</div>
                        <div className="nameConf">{Text.p6.conference}</div>
                    </div>
                    <div className='boxPaper left'>
                        <div className='title'>{Text.p5.title}</div>
                        <div className="nameConf">{Text.p5.conference}</div>
                    </div>
                    <div className='boxPaper right'>
                        <div className='title'>{Text.p4.title}</div>
                        <div className="nameConf">{Text.p4.conference}</div>
                    </div>
                    <div className='boxPaper left'>
                        <div className='title'>{Text.p3.title}</div>
                        <div className="nameConf">{Text.p3.conference}</div>
                    </div>
                    <div className='boxPaper right'>
                        <div className='title'>{Text.p2.title}</div>
                        <div className="nameConf">{Text.p2.conference}</div>
                    </div>
                    <div className='boxPaper left'>
                        <div className='title'>{Text.p1.title}</div>
                        <div className="nameConf">{Text.p1.conference}</div>
                    </div>
                </div>
            </div>

            {/* <div className='foldedCorner'><div className='fold'></div></div> */}
        {/* <div className='smallBoxPaper topPaper1'><p>مقالات</p></div>
        <div className='boxPaper topPaper2'>
            <p id='title'>طراحی بستر نرم افزاری تحلیل داده کاربران در بازی ها و طبقه بندی شاخص های ضروری</p>
            <p id="name">محمد محسن آسمان منظر، سارا آسمان منظر، بهروز مینایی</p>
            <p id="nameConf">کنفرانس تحقیقات بازی های دیجیتال، گرایش ها، فناوری ها و کاربرد ها</p>
            <p id="date">دوم و سوم آذر ماه سال ۱۳۹۶، دانشگاه علم و صنعت، تهران</p>
            <p id="link"><a href="https://civilica.com/doc/696919" target="_blank">https://civilica.com/doc/696919</a></p>
            <hr/>
            <p id="title">بررسی فرآیند داده کاوی و طبقه بندی راهکارهای حل مشکلات در مرحله پیش پردازش داده ها</p>
            <p id="name">سارا آسمان منظر</p>
            <p id="nameConf"> کنفرانس بین المللی پژوهش در مهندسی، علوم و تکنولوژی</p>
            <p id="date">سی ام تیر ۹۴ استانبول ترکیه</p>
            <p id="link"><a href="https://civilica.com/doc/398506" target="_blank">https://civilica.com/doc/398506</a></p>
            <hr/>
            <p id='title'>بیان و استخراج نیازمندی های امنیتی با استفاده از بهترین روش های موجود</p>
            <p id="name">سارا آسمان منظر، محدثه سادات قماشی</p>
            <p id="nameConf"> همایش ملی الکترونیکی دستاوردهای نوین در علوم مهندسی و پایه</p>
            <p id="date">هشتم و نهم مرداد ماه سال ۱۳۹۳</p>
            <p id="link"><a href="https://civilica.com/doc/304119" target="_blank">https://civilica.com/doc/304119</a></p>
            <hr/>
            <p id='title'>معرفی موثرترین اصول تست نرم افزار و ارزیابی معیار هاي پوشش منطقی براي توابع عادي فصلی</p>
            <p id="name">محدثه سادات قماشی، سارا آسمان منظر</p>
            <p id="nameConf">دومین همایش ملی فناوری های نوین در مهندسی برق و کامپیوتر</p>
            <p id="date">سوم مهر ۱۳۹۳، دانشگاه آزاد اسلامی واحد فسا</p>
            <p id="link"><a href="https://civilica.com/doc/337696" target="_blank">https://civilica.com/doc/337696</a></p>
            <hr/>
            <p id='title'>طبقه بندی راهکارهای پیش پردازش داده در داده کاوی و کشف دانش</p>
            <p id="name">سارا آسمان منظر، سمیه فقیه میرزایی، رضا احسن، عبدالحمید سلمان خاکسار</p>
            <p id="nameConf"> هفتمین کنفرانس ملی و اولین کنفرانس بین المللی مدیریت دانش</p>
            <p id="date">بیست و هشتم و بیست و نهم بهمن ماه ۱۳۹۳ مرکز همایش های بین المللی شهید بهشتی، تهران</p>
            <p id="link"><a href="https://civilica.com/doc/481328" target="_blank">https://civilica.com/doc/481328</a></p>
            <hr/>
            <p id='title'>اجرای موفق مهندسی نیازمندی ها با بهترین ابزارهای مطرح و مقایسه و ارزیابی آنها با معیارهای موجود</p>
            <p id="name"> محدثه سادات قماشی، سارا آسمان منظر</p>
            <p id="nameConf">همایش ملی الکترونیکی دستاوردهای نوین در علوم مهندسی و پایه</p>
            <p id="date">هشتم و نهم مرداد ماه سال ۱۳۹۳</p>
            <p id="link"><a href="https://civilica.com/doc/304021" target="_blank">https://civilica.com/doc/304021</a></p>
            <hr/>
            <p id='title'>بررسی و بهبود فرآیند تست نرم افزار براساس آزمون جهش</p>
            <p id="name"> سارا آسمان منظر، محدثه سادات قماشی</p>
            <p id="nameConf"> اولين کنفرانس ملّي الگوريتم‌هاي فراابتکاري و کاربردهاي آن در علوم و مهندسی</p>
            <p id="date">شانزدهم و هفدهم مرداد ۱۳۹۳، مؤسسه آموزش عالي غيرانتفاعي پرديسان – فريدونکنار</p>
            <hr/>
            <p id='title'>مدیریت ارتباط با مشتری و پیاده سازی آن در سازمان</p>
            <p id="name">سارا آسمان منظر</p>
            <p id="nameConf"> همایش ملی الکترونیکی دستاوردهای نوین در علوم مهندسی و پایه</p>
            <p id="date">هشتم و نهم مرداد ماه سال ۱۳۹۳</p>
            <p id="link"><a href="https://civilica.com/doc/304120" target="_blank">https://civilica.com/doc/304120</a></p>
        </div> */}
        </div>
    );
}

export default Three;